import React, { useEffect, useState } from "react";
import NoDataFound from "../utilsComponent/noDataFound";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { addDays, format } from "date-fns";
import ListsPagination from "../utilsComponent/ListsPagination";
import {
  ERROR_MESSAGE,
  functionalities,
  GOVT_PRODUCT,
  REGEX,
  SORT_ORDER,
} from "../consts";
import {
  editModeOn,
  sortList,
  validateStartDate,
  validateValueWithEndDate,
} from "../utilFunctions";
import "../scss/animalAttack.scss";
import {
  addNewAnimalAttackMaster,
  editAnimalAttackMaster,
  getAnimalAttackList,
} from "./masterServiceAPI";
import Loader from "./Loader";
import { HttpStatusCode } from "axios";

function AnimalAttackMaster(props) {
  const { roleDataCookie, productNames } = props;
  const [animalAttackList, setAnimalAttackLists] = useState([]);
  const [showAddPopover, setShowAddPopover] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);
  const [sortedBy, setSortedBy] = useState("validityEnd");
  const [sortOrder, setSortOrder] = useState(SORT_ORDER.ASC);
  const [isLoading, setLoading] = useState(false);
  const [isPopupLoading, setPopupLoading] = useState(false);
  const [productNameArray, setProductNameArray] = useState(props.productNames);
  const defaultPayload = {
    slno: null,
    createdBy: roleDataCookie?.userID,
    updatedBy: null,
    validityStart: null,
    validityEnd: null,
    multiplicationFactor: 0,
    productId: null,
    productName: null,
  };
  const [animalAttackPayload, setAnimalAttackPayload] =
    useState(defaultPayload);

  const getListData = async () => {
    const response = await getAnimalAttackList();
    setLoading(true);
    if (response?.status === HttpStatusCode.Ok) {
      setAnimalAttackLists(sortList(sortedBy, sortOrder, response?.data));
      setLoading(false);
    } else if (!animalAttackList && animalAttackList.length === 0) {
      toast.error("Failed to get data");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.productNames?.length) {
      setProductNameArray(
        props.productNames.filter(
          (product) => !GOVT_PRODUCT.includes(product?.label)
        )
      );
    }
  }, [productNames]);

  useEffect(() => {
    getListData();
  }, []);

  const handleDateChange = (date, key) => {
    if (date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const dat1 = date.getDate().toString().padStart(2, "0");
      setAnimalAttackPayload({
        ...animalAttackPayload,
        [key]: `${year}-${month}-${dat1}`,
      });
    }
  };

  const addAnimalAttackMaster = async () => {
    const sortedList = sortList(
      "validityEnd",
      SORT_ORDER.DESC,
      animalAttackList
    );
    const validatedStartDateData = validateStartDate(
      sortedList,
      animalAttackPayload,
      "validityStart",
      "validityEnd",
      editMode
    );
    if (!animalAttackPayload.productId) {
      toast.error("Please select product name.");
      return;
    } else if (!animalAttackPayload.multiplicationFactor) {
      toast.error("Please enter multiplication factor");
      return;
    } else if (animalAttackPayload.multiplicationFactor > 100) {
      toast.error("Multiplication factor can not be greater than 100");
      return;
    } else if (!animalAttackPayload.validityStart) {
      toast.error("Please select validity start date.");
      return;
    } else if (!animalAttackPayload.validityEnd) {
      toast.error("Please select validity end date.");
      return;
    } else if (
      validateValueWithEndDate(
        sortedList,
        animalAttackPayload,
        "multiplicationFactor",
        "validityEnd",
        editMode
      )
    ) {
      toast.error("Please select different multiplication factor");
      return;
    } else if (validatedStartDateData.isAvailable) {
      toast.error(validatedStartDateData.message);
      return;
    } else {
      const data = {
        ...animalAttackPayload,
        productId: animalAttackPayload.productId,
        updatedBy: roleDataCookie?.userID,
      };
      if (editMode) {
        setPopupLoading(true);
        const response = await editAnimalAttackMaster(data);
        if (response?.status === HttpStatusCode.Ok) {
          setPopupLoading(false);
          setEditMode(false);
          setAnimalAttackPayload(defaultPayload);
          getListData();
          toast.success("Animal attack updated successfully");
          setShowAddPopover(false);
        } else {
          setPopupLoading(false);
          toast.error(response?.data || ERROR_MESSAGE);
        }
      } else {
        setPopupLoading(true);
        const response = await addNewAnimalAttackMaster(data);
        if (response?.status === HttpStatusCode.Ok) {
          setPopupLoading(false);
          setAnimalAttackPayload(defaultPayload);
          getListData();
          toast.success("Animal attack added successfully");
          setShowAddPopover(false);
        } else {
          setPopupLoading(false);
          toast.error(response?.data || ERROR_MESSAGE);
        }
      }
    }
  };
  const clickedOnEditMode = (data) => {
    const editData = {
      slno: data.slno,
      productId: data.productId,
      productName: data.productName,
      multiplicationFactor: Number(data.multiplicationFactor || 0).toFixed(2),
      validityStart: data.validityStart,
      validityEnd: data.validityEnd,
      createdBy: roleDataCookie?.userID,
    };
    setAnimalAttackPayload(editData);
    setEditMode(true);
    setShowAddPopover(true);
  };

  const handleAdd = () => {
    setShowAddPopover(!showAddPopover);
  };
  const addAnimalAttack = () => {
    setAnimalAttackPayload(defaultPayload);
    setShowAddPopover(!showAddPopover);
    setEditMode(false);
  };
  const sortingData = (sortedByColumn) => {
    let order = SORT_ORDER.ASC;
    if (sortedByColumn === sortedBy) {
      order = sortOrder === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC;
    }
    setSortedBy(sortedByColumn);
    setSortOrder(order);
    setAnimalAttackLists(sortList(sortedByColumn, order, animalAttackList));
  };

  const getAddPopup = () => {
    return (
      <Modal
        show={showAddPopover}
        isOpen={showAddPopover}
        toggle={handleAdd}
        centered={true}
        backdrop={"static"}
      >
        <ModalHeader>
          {editMode ? (
            <h5>Edit Animal Attack Master</h5>
          ) : (
            <h5>Add Animal Attack Master</h5>
          )}
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleAdd}
          ></button>
        </ModalHeader>
        <ModalBody>
          <div className="form-group mb-3">
            <form action>
              <div className="form-group mb-3">
                <label for="productNameSelect" className="form-label">
                  Product Name
                </label>
                <Select
                  id="productNameSelect"
                  options={productNameArray}
                  isDisabled={editMode}
                  onInputChange={(inputValue) => {
                    const cleanedValue = inputValue.replace(
                      REGEX.ALPHABET_REGEX,
                      ""
                    );
                    return cleanedValue;
                  }}
                  placeholder="Kshema Product"
                  value={
                    animalAttackPayload?.productName
                      ? {
                          value: animalAttackPayload.productId,
                          label: animalAttackPayload?.productName,
                        }
                      : { label: "Product" }
                  }
                  onChange={(data) => {
                    setAnimalAttackPayload({
                      ...animalAttackPayload,
                      productId: data.value,
                      productName: data.label,
                    });
                  }}
                />
              </div>
              <div className="form-group mb-3">
                <label for="multiplicationFactorInput" className="form-label">
                  Multiplication Factor %
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="multiplicationFactorInput"
                  placeholder="Multiplication Factor %"
                  onChange={(e) => {
                    let numericValue = e.target.value.replace(
                      REGEX.NUMBER_WITH_DOT,
                      ""
                    );
                    numericValue = numericValue.replace(
                      REGEX.NO_ZERO_START,
                      ""
                    );
                    setAnimalAttackPayload({
                      ...animalAttackPayload,
                      multiplicationFactor: isNaN(Number(numericValue))
                        ? 0
                        : numericValue,
                    });
                  }}
                  value={animalAttackPayload.multiplicationFactor}
                />
              </div>
              <div className="form-group mb-3">
                <label for="validityStart" className="form-label">
                  Validity Start
                </label>
                <div className="form-control">
                  <DatePicker
                    id="validityStart"
                    selected={
                      animalAttackPayload?.validityStart &&
                      animalAttackPayload?.validityStart
                    }
                    onChange={(date) => handleDateChange(date, "validityStart")}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    className="no-border"
                    onKeyDown={(e) => e.preventDefault()}
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={1000}

                  />
                </div>
              </div>
              <div className="form-group mb-3">
                <label for="validityEnd" className="form-label">
                  Validity End
                </label>
                <div className="form-control">
                  <DatePicker
                    id="validityEnd"
                    selected={
                      animalAttackPayload?.validityEnd &&
                      animalAttackPayload?.validityEnd
                    }
                    onChange={(date) => handleDateChange(date, "validityEnd")}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    className="no-border"
                    onKeyDown={(e) => e.preventDefault()}
                    showYearDropdown
                    showMonthDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={1000}

                  />
                </div>
              </div>
            </form>
          </div>
        </ModalBody>
        <ModalFooter className="modal-footer">
          <Button
            className="save-button"
            onClick={() => addAnimalAttackMaster()}
            disabled={isPopupLoading}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    );
  };
  return (
    <section className="p-4">
      <h1 className="headerclaim">Animal Attack Master</h1>
      <hr className="upper_hr" />
      <div className="outer-box_vendorMasters">
        <div className="div-parent">
          <h2 className="heading_h2Masters">Animal Attack Master</h2>
          {editModeOn(functionalities.ANIMAL_ATTACK_MASTER_TAB) && (
            <button
              className="btn btn-success px-4 add-button"
              onClick={() => addAnimalAttack()}
            >
              <i className="fa fa-plus" aria-hidden="false"></i> Add
            </button>
          )}
          {getAddPopup()}
        </div>
        {animalAttackList && animalAttackList.length > 0 && (
          <>
            <table className="table mt-3 text-left">
              <thead className="row-border">
                <tr>
                  <th className="row-border">S NO.</th>
                  <th className="row-border">
                    Product Name
                    <a
                      className="pointer text-body ms-1"
                      onClick={() => sortingData("productName")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="pointer"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-filter"
                        viewBox="0 0 16 16"
                      >
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                      </svg>
                    </a>
                  </th>
                  <th className="row-border">
                    Multiplication Factor %
                    <a
                      className="pointer text-body ms-1"
                      onClick={() => sortingData("multiplicationFactor")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="pointer"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-filter"
                        viewBox="0 0 16 16"
                      >
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                      </svg>
                    </a>
                  </th>
                  <th className="row-border">Validity Start</th>
                  <th className="row-border">Validity End</th>
                  {editModeOn(functionalities.ANIMAL_ATTACK_MASTER_TAB) && (
                    <th className="row-border">Action</th>
                  )}
                </tr>
              </thead>
              <tbody className="row-border">
                {currentItems.map((list, index) => (
                  <tr key={index}>
                    <td className="row-border">{index + 1}</td>
                    <td className="row-border">{list?.productName}</td>
                    <td className="row-border">{Number(list.multiplicationFactor || 0).toFixed(2)}%</td>
                    <td className="row-border">
                      {format(new Date(list.validityStart), "dd-MMM-yyyy")}
                    </td>
                    <td className="row-border">
                      {format(new Date(list.validityEnd), "dd-MMM-yyyy")}
                    </td>
                    {editModeOn(functionalities.ANIMAL_ATTACK_MASTER_TAB) && (
                      <td
                        onClick={() => {
                          clickedOnEditMode(list);
                        }}
                        className="d-flex align-items-center justify-content-center table-row-bg"
                      >
                        <FontAwesomeIcon
                          icon="fas fa-edit"
                          className="edit_button"
                        />
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            <ListsPagination
              setCurrentItems={setCurrentItems}
              lists={animalAttackList}
            />
          </>
        )}
        {(!animalAttackList || animalAttackList.length === 0) && !isLoading && (
          <NoDataFound text="No Data Found" />
        )}
        {isLoading && <Loader />}
      </div>
    </section>
  );
}

export default AnimalAttackMaster;
